import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PercentIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      height={22}
      viewBox="0  0 22 22"
      width={22}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M4.5 1.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM.25 4.5a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0Zm20.28-3.03a.75.75 0 0 1 0 1.06l-18 18a.75.75 0 0 1-1.06-1.06l18-18a.75.75 0 0 1 1.06 0ZM17.5 14.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm-4.25 2.75a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
